export const ROUTER_URLS = {
  root: '/',
  serviceOrder: 'service-order',
  residential: 'residential',
  commercial: 'commercial',
  rollOff: 'roll-off',
  congratulations: 'congratulations',
  demo: 'demo',
  error404: '**',
  error500: 'error-500',
} as const;
